import { useState, useEffect } from 'react';
import hyperFormulaService from '@/services/hyperFormula';
import { spreadsheet as spreadsheetCore } from '@industriousapps/excelkits-core';
// NOTE: Not Publishable! Used for value
// type lookups and example value previews,
// should not be used to render widget results
export default function useCompiledWorkbook() {
  let {
    workbook
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    0: compiledWorkbook,
    1: setCompiledWorkbook
  } = useState([]);
  useEffect(() => {
    if (!workbook || !spreadsheetCore.hasContent(workbook)) return;
    hyperFormulaService.load().then(() => {
      setCompiledWorkbook(hyperFormulaService.hyperFormulaToWorkbook(hyperFormulaService.workbookToHyperFormula(workbook)));
    });
  }, [workbook, setCompiledWorkbook]);
  return {
    compiledWorkbook
  };
}